import { PaperClipOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button } from 'antd';
import React, { useState } from 'react';
import { CreditNoteModal } from './CreditNoteModal';

interface IProps {
  documentId?: string;
  fileName?: string;
  onChange: (documentId: string | undefined, fileName: string | undefined) => void;
}

/**
 * "Attach credit note" link that opens the capture modal (upload or phone QR) and reports the
 * chosen document back to the parent. Manages its own modal open-state.
 */
export const CreditNoteField: React.FC<IProps> = ({ documentId, fileName, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <Button
        type="link"
        size="small"
        icon={<PaperClipOutlined />}
        style={{ padding: 0, height: 'auto' }}
        onClick={() => setOpen(true)}
      >
        {fileName || L('Attach credit note (optional)')}
      </Button>
      {documentId && (
        <Button type="text" size="small" danger onClick={() => onChange(undefined, undefined)}>
          {L('Remove')}
        </Button>
      )}
      <CreditNoteModal
        open={open}
        onClose={() => setOpen(false)}
        onAttach={(id, name) => {
          onChange(id, name);
          setOpen(false);
        }}
      />
    </div>
  );
};

export default CreditNoteField;
